import React from "react";
import MassDeleteOfCampaigns from "./mass-delete/campaign-mass-delete";
import MassUpdateOfCampaigns from "./mass-update/campaign-mass-update";
import { CampaignActionHandlerProps } from "./campaign-action-type";
import ExportCampaigns from "./export-campaigns/export-campaigns";

const CampaignActionHandler: React.FC<CampaignActionHandlerProps> = ({
  selectedCampaigns,
  setSelectedCampaignsMap,
  selectedActions,
  setSelectedActions,
  menuItems,
  setMenuItems,
  fetchCampaigns,
  selectedLeadActionScope,
  setselectedLeadActionScope,
  totalRecords,
  handleMassActionMenuClose,
}) => {
  const fetchIsOpen = (action: string) => {
    return menuItems.find((item) => item.value === action)?.isOpen || false;
  };

  return (
    <div className="lead-action-handler">
      <MassUpdateOfCampaigns
        campaignIds={Object.values(selectedCampaigns).flat() || []}
        isOpen={fetchIsOpen("Update")}
        setMenuItems={setMenuItems}
        selectedActions={selectedActions}
        setSelectedActions={setSelectedActions}
        fetchCampaigns={fetchCampaigns}
        selectedLeadActionScope={selectedLeadActionScope}
        setselectedLeadActionScope={setselectedLeadActionScope}
        totalRecords={totalRecords}
        handleMassActionMenuClose={handleMassActionMenuClose}
        setSelectedCampaignsMap={setSelectedCampaignsMap}
      />
      <MassDeleteOfCampaigns
        campaignIds={Object.values(selectedCampaigns).flat() || []}
        isOpen={fetchIsOpen("Archive")}
        setMenuItems={setMenuItems}
        selectedActions={selectedActions}
        setSelectedActions={setSelectedActions}
        fetchCampaigns={fetchCampaigns}
        setSelectedCampaignsMap={setSelectedCampaignsMap}
        selectedLeadActionScope={selectedLeadActionScope}
        setselectedLeadActionScope={setselectedLeadActionScope}
        totalRecords={totalRecords}
        handleMassActionMenuClose={handleMassActionMenuClose}
      />
      <ExportCampaigns
        campaignIds={Object.values(selectedCampaigns).flat() || []}
        isOpen={fetchIsOpen("Export Campaigns")}
        setMenuItems={setMenuItems}
        selectedActions={selectedActions}
        fetchCampaigns={fetchCampaigns}
        handleMassActionMenuClose={handleMassActionMenuClose}
        setSelectedCampaignsMap={setSelectedCampaignsMap}
      />
    </div>
  );
};

export default CampaignActionHandler;
